import React, { Component } from "react";
import Cinema from "./Cinema";
import _ from "lodash";

class ShowtimesResults extends Component {
  render() {
    if (!this.props.results.showtimes) {
      return <div />;
    }
    const {
      showtimes,
      movie,
      location,
      timeFrom,
      timeTo,
      cinemas
    } = this.props.results;
    const byCinemas = _.groupBy(this.props.results.showtimes, "cinema_id");

    return (
      <div className="page showtimes-results">
        <h2>
          {showtimes.length > 0
            ? "Cinemas playing " +
                movie +
                " near " +
                location +
                " from  " +
                timeFrom +
                " to " +
                timeTo
            : ""}
        </h2>
        <h3>List of Cinemas</h3>
        {_.map(byCinemas, (sessions, id) => {
          return <Cinema key={id} showtimes={sessions} cinema={cinemas[id]} />;
        })}
      </div>
    );
  }
}

export default ShowtimesResults;



// WEBPACK FOOTER //
// ./src/components/ShowtimesResults.js